export default function SGHero() {
  return (
    <section className="relative pt-36 pb-0 overflow-hidden">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-end">
          {/* Left — text */}
          <div className="pb-16">
            <span
              className="inline-flex items-center gap-2 text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-8"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              <span className="w-6 h-px bg-[#C8BAA8] inline-block" />
              Style Guide
            </span>

            <h1
              className="text-[#2C2825] text-5xl md:text-6xl lg:text-[70px] leading-[1.05] mb-7"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
            >
              Style Guide for<br />
              <em>a Calm Home</em>
            </h1>

            <p
              className="text-[#8B8378] text-base leading-relaxed mb-10 max-w-md"
              style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
            >
              A simple guide to soft colors, natural materials, warm minimal styling,
              and peaceful home atmosphere.
            </p>

            <a
              href="#guide-start"
              className="inline-flex items-center gap-2.5 bg-[#2C2825] text-[#FAF7F0] px-9 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#3A3632] transition-colors cursor-pointer whitespace-nowrap uppercase"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Read the Guide
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-arrow-down-line text-xs" />
              </span>
            </a>

            {/* Divider / stats row */}
            <div className="flex items-center gap-10 mt-14 pt-10 border-t border-[#EDE6DA]">
              {[
                { num: "4", label: "Sections" },
                { num: "20+", label: "Styling Tips" },
                { num: "6", label: "Color Palettes" },
              ].map((stat) => (
                <div key={stat.label}>
                  <p
                    className="text-[#2C2825] text-3xl leading-none"
                    style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
                  >
                    {stat.num}
                  </p>
                  <p
                    className="text-[#B5A898] text-[10px] tracking-widest mt-1.5 uppercase"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — editorial image, flush to bottom */}
          <div className="relative hidden lg:block">
            <div className="rounded-t-2xl overflow-hidden aspect-[3/4] bg-[#F5F1E8]">
              <img
                src="https://public.readdy.ai/ai/img_res/e73d4d3a0361fb7c8004bc590fb8f98f.jpg"
                alt="Style guide calm interior"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating label */}
            <div className="absolute bottom-8 -left-6 bg-[#FAF7F0] rounded-xl px-6 py-4 max-w-[200px]">
              <p
                className="text-[#2C2825] text-sm leading-snug italic"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                "Less, but beautifully chosen."
              </p>
              <p
                className="text-[#B5A898] text-[9px] tracking-widest mt-2 uppercase"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Calm Spaces Journal
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
